import { TextContext } from "hocs"
import React, { useContext } from "react"
import * as Styled from "./QualityIndication.styles"
import { string, number, shape, oneOfType } from "prop-types"
import { BarGraph, Tooltip as InfoIcon } from "components/atoms"


// TODO for new TS version we need unit test !!!!!!!!!!! (alda immer ruhig durch die Hose atmen)
const QualityIndication = ({ qualityIndication }) => {
  const [showAverageValues, setShowAverageValues] = React.useState(false)
  const textContext = useContext(TextContext)
  const {
    label = '',
    labelShort = '',
    federalAverage,
    treatmentCases,
    achievedValue,
    preText,
    postText,
    tooltip,
  } = qualityIndication

  // get class for content alignment
  const getFooterClass = () => {
    let footerClass = 'bargraph-footer'
    if (treatmentCases && federalAverage) {
      footerClass += ' space-between'
    } else if (federalAverage) {
      footerClass += ' right-align'
    } else if (treatmentCases) {
      footerClass += ' left-align'
    }
    return footerClass
  }

  return (
    <Styled.QualityIndication ratingAverage={ federalAverage }>
      {achievedValue && (
        <>
          {label && (
            <p>
              <span className='headline'>{label}</span>
            </p>
          )}
          {preText && <p>{preText}</p>}

          <div className='quality-indication-bargraph-container'>
            <span className={ 'single-peq-label' }>
              {`${ labelShort } `}
              {federalAverage && showAverageValues && (
                <span className='average-value'>
                  (&empty; {federalAverage}%)
                </span>
              )}
            </span>
            <div className='bargraph-container'>
              <BarGraph
                className={ 'peq-bar-graph' }
                percent={ achievedValue }
                average={ federalAverage }
                showAverage={ showAverageValues }
              />
            </div>
          </div>

          {(treatmentCases || federalAverage) && (
            <div className={ getFooterClass() }>
              {treatmentCases && (
                <div className='treatments-container'>
                  <span className='treatments-count-value'>
                    {`${ textContext['qualityIndication.treatmentsCount'] } ${ treatmentCases }`}
                  </span>
                  {tooltip && tooltip?.tip && tooltip?.title && (
                    <div className='tooltip-container'>
                      <InfoIcon
                        arrow='left'
                        dialogTitle={ tooltip.title }
                        infoIconId='info-icon'
                        tooltipId='tooltip'
                        closeOnClickOutside={ true }>
                        {tooltip.tip}
                      </InfoIcon>
                    </div>
                  )}
                </div>
              )}

              {federalAverage && (
                <span
                  className={ 'toggle-link' }
                  onClick={ () => setShowAverageValues(!showAverageValues) }>
                  {showAverageValues
                    ? textContext['peq.average.hide']
                    : textContext['peq.average.show']}
                </span>
              )}
            </div>
          )}

          {postText && <p>{postText}</p>}
        </>
      )}
    </Styled.QualityIndication>
  )
}

QualityIndication.propTypes = {
  qualityIndication: shape({
    /* modul label */
    label: string,
    /* bundesdurchschnitt */
    federalAverage: number,
    /* behandlungsfälle */
    treatmentCases: number,
    /* erreichter wert */
    achievedValue: oneOfType([string, number]),
    /* tooltip data */
    tooltip: {
      tip: string,
      title: string,
    },
    /* additional text props */
    preText: string,
    postText: string,
  }),
}

export default QualityIndication
